module.exports = __webpack_public_path__ + "img/home_img03.e2ab9e2a.png";